import { StartEvaluationInput, StartEvaluationResponse } from '@/models/gen/graphql';

import { StartEvaluationDocument } from '@/api/queries';
import graphApi from '@/api';
import useSession from '@/state/session';

const [_, runStartEvaluation] = graphApi(StartEvaluationDocument);

export const startEvaluation = async (subjectUserId: string): Promise<StartEvaluationResponse> => {
  const evaluatorUserId = useSession.getState().state.user?.id;
  if (!evaluatorUserId) throw new Error('startEvaluation: no logged in user id found');

  const input: StartEvaluationInput = { subjectUserId, evaluatorUserId };
  const res = await runStartEvaluation({ input });

  return res?.startEvaluation;
};
